module.exports = __webpack_public_path__ + "img/6.9c7b68d3.jpg";